import React from 'react';
import { connect } from 'react-redux';
import StatisticsByUTMContent from './StatisticsByUTMContent.js';
import { actions } from './StatisticsByUTMContent.actions';

const StatisticsByUTMContentComponent = connect(
    function mapStateToProps(state) {
        const serverStore = state?.serverStorage?.store || {};
        const storedMetrics =
            state?.statistics?.data?.parameters?.metricsBinary ||
            serverStore?.reportByUTM?.metrics ||
            serverStore?.report?.metrics;

        return {
            loadingData: state.statistics.data.loading,
            totalPages: state.statistics.data.total,
            page: state.statistics.data.page,
            metrics: typeof storedMetrics === 'string' ? storedMetrics : '',
            serverStorageReady: !!state.serverStorage.loaded
        };
    },
    function mapDispatchToProps(dispatch) {
        return {
            search: actions.search,
            setQuery: actions.setQuery
        };
    }
)(StatisticsByUTMContent);

export default StatisticsByUTMContentComponent;
